import { useState } from "react";
import api from "api";
import Swal from "sweetalert2";




export default function useCustomerMessage({
  request,
  config,
  onAfterSend,
}) {
  const [customerMessageModalIsOpen, setCustomerMessageModalIsOpen] = useState(false);
  const [messageContext, setMessageContext] = useState(null);
  const [waitingStatus, setWaitingStatus] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [message, setMessage] = useState({
    subject: "",
    body: "",
  });

  // ----------------------------------
  // Utils
  // ----------------------------------
  // ${request.assignee?.userFirstname ?? ""} ${request.assignee?.userName ?? ""}
  const buildSignature = () => `
<p>
Bien cordialement<br />
Fortium Formalités

</p>
`.trim();

  const buildFooter = () => `
<p>
Vous pouvez retrouver cette demande de formalité dans votre
<a href="${config.site_url}/customer/account/">espace client</a>.
</p>
`.trim();

  // ----------------------------------
  // Open message (blank)
  // ----------------------------------
  const openBlankMessage = () => {
    setMessageContext('custom');
    setAttachments([]);
    const body = `
<p style="color:#800000; font-size:12px;  class="text-danger">Ceci est un message automatique. Veuillez ne pas répondre.</p>
    <p>Bonjour</p>
<p>...</p>
${buildFooter()}
${buildSignature()}
`.trim();

    setMessage({
      subject: "Votre formalité " + request.frCustomName,
      body,
    });

    setCustomerMessageModalIsOpen(true);
  };

  // ----------------------------------
  // Open message from backend template
  // ----------------------------------
  const openMessageFromTemplate = async (context) => {
    setMessageContext(context);
    let subject
    switch (context) {
      case 'rejection':
        subject = "Erreur sur votre demande de formalité " + request.frCustomName;
        break;
      case 'sendDocuments':

        subject = "Finalisation de votre demande de formalité " + request.frCustomName;
        break;
      default:
        subject = "Votre formalité " + request.frCustomName;
    }
    const res = await api.get(
      `/admin/formalities/request/${request.frId}/messages/${context}`
    );
    if (!res.data?.content) {
      return;
    }
    const body = `
    <p style="color:#800000; font-size:12px" class="text-danger">Ceci est un message automatique. Veuillez ne pas répondre.</p>
<p>Bonjour,</p>
${res.data.content}
${buildFooter()}
${buildSignature()}
`.trim();
    setMessage({
      subject: subject,
      body,
    });

    if (Array.isArray(res.data.attachments)) {
      setAttachments(res.data.attachments);
    } else {
      setAttachments([]);
    }
    setCustomerMessageModalIsOpen(true);
  };


  // ----------------------------------
  // Send message
  // ----------------------------------
  const sendMessage = async ({
    cc,
    subject,
    body,
    attachments = [],
    ...rest
  }) => {
    try {
      const recipients = [];
      recipients.push({
        name: (request.frData.tab_intro.prenom || "") + " " + (request.frData.tab_intro.nom || ""),
        email: request.frData.tab_intro.email || ""
      })
      // On ne garde que les paths

      const payload = {
        from_name: "Fortium Formalités",
        reply_to: "noreply@fortium.fr",
        recipients,
        subject: subject || "",
        body: body || "",
        setWaitingStatus: waitingStatus ? 1 : 0,
        attachments: attachments,
        ...rest
      };
      await api.post(
        `/admin/formalities/request/${request.frId}/message`,
        payload
      );

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Message envoyé au client",
        showConfirmButton: false,
        timer: 3000,
      });

      setCustomerMessageModalIsOpen(false);

      if (typeof onAfterSend === "function") {
        await onAfterSend(messageContext);
      }

    } catch (e) {
      console.error(e);
      Swal.fire({
        icon: "error",
        title: "Erreur",
        text: "Erreur lors de l’envoi du message",
      });
    }
  };
  return {
    customerMessageModalIsOpen,
    message,
    attachments, // ⬅️ exposées au parent
    waitingStatus,
    setWaitingStatus,
    openBlankMessage,
    openMessageFromTemplate,
    sendMessage,
    closeMessage: () => setCustomerMessageModalIsOpen(false),
  };
}
